import { call, delay } from "redux-saga/effects"
import { get as getApi } from "api"
import { log } from "helpers/logger"
import { saga } from "../newVersion"

jest.mock("api")
jest.mock("helpers/logger")

describe("newVersion saga", () => {
  beforeEach(() => {
    Object.assign(window, { CLIENT_VERSION: "abc123" })
  })

  afterEach(() => {
    Reflect.deleteProperty(window, "CLIENT_VERSION")
  })

  it("waits 10 minutes after a failed poll instead of retrying at once", () => {
    const error = new Error("network down")
    const generator = saga()

    expect(generator.next().value).toEqual(call(getApi, "/api/client/version", true))
    expect(generator.throw(error).value).toEqual(delay(600000))
    expect(log).toHaveBeenCalledWith(error)
    expect(generator.next().value).toEqual(call(getApi, "/api/client/version", true))
  })

  it("waits 10 minutes after a poll that finds the same version", () => {
    const generator = saga()

    generator.next()

    expect(generator.next("abc123").value).toEqual(delay(600000))
  })
})
